import React from 'react';

const Loader = () => {
  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-white/80 backdrop-blur-sm">
      <div className="relative flex flex-col items-center">
        {/* Animated Container */}
        <div className="relative w-24 h-24">
          {/* Outer Rotating Gradient Ring */}
          <div className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-blue-600 border-r-purple-600 border-b-blue-600 border-l-purple-600 animate-spin-slow shadow-lg"></div>

          {/* Inner Reverse Rotating Ring */}
          <div className="absolute inset-2 rounded-full border-[3px] border-transparent border-t-purple-500 border-r-blue-500 border-b-purple-500 border-l-blue-500 animate-reverse-spin opacity-70"></div>

          {/* Central 3D Flip Element */}
          <div className="absolute inset-0 flex items-center justify-center perspective-1000">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-purple-700 rounded-xl flex items-center justify-center shadow-xl animate-flip-3d backface-visible">
              <span className="text-xl font-bold text-white tracking-wider drop-shadow-md">MMF</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
